<div class="file-icon {{sizeClass}}" [class.grayscale]="grayscale" [attr.data-type]="extension"></div>
